const getMetafield = (product, key, match) => {
    if (match === "includes") return product?.metafields?.edges?.filter((metafield) => metafield.node.key.includes(key));
    if (match === "exactMatch") return product?.metafields?.edges?.find((metafield) => metafield.node.key === key);
    return undefined;
};

export default getMetafield;
